function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    display: -webkit-box;\n    -webkit-line-clamp: 5;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  text-base: base;\n  white-space: pre-wrap;\n  \n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  color: #3b82f6; /* text-blue-500 */\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n  margin-top: 0.25rem; /* mt-1 */\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  \n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: #3b82f6; /* text-blue-500 */\n  \n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem; /* text-sm */\n  margin-bottom: 0.5rem; /* mb-2 */\n  white-space: pre-wrap;\n  color: #1f2937; /* text-gray-800 */\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem; /* text-xs */\n  color: #6b7280; /* text-gray-500 */\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  color: #6b7280; /* text-gray-500 */\n  font-size: 0.875rem; /* text-sm */\n  margin: 0 0.25rem; /* mx-1 */\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// 텍스트 스타일
export var ContentText = styled.div(_templateObject1(), function(props) {
    return props.isClipped && css(_templateObject());
});
export var ExpandButton = styled.button(_templateObject2());
export var StyledLink = styled.a(_templateObject3());
export var QuotedContentText = styled.div(_templateObject4());
export var DateText = styled.span(_templateObject5());
export var UsernameSeparator = styled.span(_templateObject6());
